<template>
  <div>
    <b-row>
      <b-col md="3">
        <b-form-group
          label="Product"
        >
          <custom-v-select
            v-model="selectedProduct"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="filterProductOptions"
            label="display_text"
            placeholder="Search product..."
            @search="onProductSearch"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Company"
        >
          <custom-v-select
            id="company"
            v-model="selectedCompanies"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="companyOptions"
            label="text"
            placeholder="Select Company"
            multiple
            :close-on-select="false"
            :deselect-from-dropdown="true"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="MRP Range"
        >
          <b-row>
            <b-col cols="6">
              <b-form-input
                v-model.number="mrpMin"
                type="number"
                min="0"
                max="999999"
                placeholder="Min"
                @input="debouncedFiltersChange"
              />
            </b-col>
            <b-col cols="6">
              <b-form-input
                v-model.number="mrpMax"
                type="number"
                min="0"
                max="999999"
                placeholder="Max"
                @input="debouncedFiltersChange"
              />
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Amount Range"
        >
          <b-row>
            <b-col cols="6">
              <b-form-input
                v-model.number="amountMin"
                type="number"
                min="0"
                max="999999"
                placeholder="Min"
                @input="debouncedFiltersChange"
              />
            </b-col>
            <b-col cols="6">
              <b-form-input
                v-model.number="amountMax"
                type="number"
                min="0"
                max="999999"
                placeholder="Max"
                @input="debouncedFiltersChange"
              />
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group label="Buyer">
          <custom-v-select
            v-model="selectedBuyers"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="buyerOptions"
            label="text"
            placeholder="Select Buyers"
            multiple
            :reduce="data => data.id"
            :deselect-from-dropdown="true"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Date Range"
        >
          <flat-picker
            v-model="dateRange"
            placeholder="Select Date Range"
            :config="{ mode: 'range'}"
          />
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group label="Salesman">
          <custom-v-select
            v-model="selectedCreatedBy"
            :options="usersList"
            label="full_name"
            placeholder="Select Salesman"
            multiple
            :reduce="data => data.id"
            :deselect-from-dropdown="true"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col md="2">
        <!-- Sort By Toggle -->
        <div class="d-flex align-items-center justify-content-between mt-2 fw-medium position-relative">
          <b-form-checkbox
            v-model="showSortOptions"
            @change="toggleSortOptions"
          >
            Sort By Priority
          </b-form-checkbox>

          <!-- Sort Options Dropdown -->
          <div
            v-if="showSortOptions"
            v-click-outside="closeSortOptions"
            class="sort-dropdown"
          >
            <div class="sort-dropdown-header">
              <span>Drag to reorder priority</span>
            </div>
            <div class="sort-priority-container">
              <div class="sort-items-wrapper">
                <div
                  v-for="(option, index) in sortByOptions"
                  :key="option.value"
                  class="sort-item"
                  :class="{ 'active': option.enabled, 'dragging': draggedIndex === index }"
                  draggable="true"
                  @dragstart="handleDragStart(index, $event)"
                  @dragover.prevent="handleDragOver(index, $event)"
                  @drop="handleDrop(index, $event)"
                  @dragend="handleDragEnd"
                >
                  <div class="d-flex align-items-center">
                    <span class="priority-number">{{ index + 1 }}</span>
                    <b-form-checkbox
                      v-model="option.enabled"
                      class="mx-2"
                      @change="filtersChangeHandler"
                    >
                      {{ option.label }}
                    </b-form-checkbox>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="drag-handle"
                    >
                      <polyline points="5 9 2 12 5 15" />
                      <polyline points="9 5 12 2 15 5" />
                      <polyline points="15 19 12 22 9 19" />
                      <polyline points="19 9 22 12 19 15" />
                      <line
                        x1="2"
                        y1="12"
                        x2="22"
                        y2="12"
                      />
                      <line
                        x1="12"
                        y1="2"
                        x2="12"
                        y2="22"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex align-items-center justify-content-between fw-medium">
          <b-form-checkbox
            v-model="reminder_requested"
            @change="filtersChangeHandler"
          >
            Reminder Requested
          </b-form-checkbox>
        </div>
        <div class="d-flex align-items-center justify-content-between fw-medium">
          <b-form-checkbox
            v-model="reminder_acknowledged"
            @change="filtersChangeHandler"
          >
            Reminder Acknowledged
          </b-form-checkbox>
        </div>
      </b-col>
      <b-col md="2">
        <div class="d-flex align-items-center justify-content-between mt-1 fw-medium">
          <b-form-checkbox
            v-model="out_of_stock"
            @change="filtersChangeHandler"
          >
            Out Of Stock
          </b-form-checkbox>
        </div>
        <div class="d-flex align-items-center justify-content-between fw-medium">
          <b-form-checkbox
            v-model="in_stock"
            @change="filtersChangeHandler"
          >
            In Stock
          </b-form-checkbox>
        </div>
        <div class="d-flex align-items-center justify-content-between fw-medium">
          <b-form-checkbox
            v-model="remove_duplicates"
            @change="filtersChangeHandler"
          >
            Remove Duplicates
          </b-form-checkbox>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  VBTooltip, BRow, BCol, BFormGroup,
  BFormCheckbox,
  BFormInput,
} from 'bootstrap-vue'
import axios from 'axios'
import FlatPicker from '@/components/UI/FlatPicker.vue'
import CustomVSelect from '@/components/UI/CustomVSelect.vue'
import dateMixin from '@/mixins/dateMixin'
import formatMixin from '@/mixins/formatMixin'

// WeakMap to store click handlers
const clickOutsideHandlers = new WeakMap()

export default {
  directives: {
    'b-tooltip': VBTooltip,
    'click-outside': {
      bind(el, binding) {
        const handler = event => {
          // Check if click is outside the element
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event)
          }
        }
        // Store handler in WeakMap
        clickOutsideHandlers.set(el, handler)
        document.addEventListener('click', handler)
      },
      unbind(el) {
        const handler = clickOutsideHandlers.get(el)
        if (handler) {
          document.removeEventListener('click', handler)
          clickOutsideHandlers.delete(el)
        }
      },
    },
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    CustomVSelect,
    FlatPicker,
    BFormCheckbox,
    BFormInput,
  },
  mixins: [dateMixin, formatMixin],
  data() {
    return {
      selectedProduct: null,
      productOptions: [],
      filterProductOptions: [],
      dateRange: `${this.formatedDate(
        new Date(Date.now()),
        'YYYY-MM-DD',
      )} to ${this.formatedDate(
        new Date(Date.now()),
        'YYYY-MM-DD',
      )}`,
      mrpMin: null,
      mrpMax: null,
      amountMin: null,
      amountMax: null,
      out_of_stock: false,
      in_stock: false,
      remove_duplicates: false,
      reminder_requested: false,
      reminder_acknowledged: false,
      companyOptions: [],
      selectedCompanies: [],
      productCode: '',
      selectedCreatedBy: null,
      usersList: [],
      selectedBuyers: null,
      buyerOptions: [],
      codeInputTimeout: null,
      sortByOptions: [
        { value: 'company', label: 'Company', enabled: false },
        { value: 'product_name', label: 'Product Name', enabled: false },
        { value: '-rate', label: 'Rate', enabled: false },
        { value: '-amount', label: 'Amount', enabled: false },
      ],
      draggedIndex: null,
      showSortOptions: false,
      searchTimeout: null,
    }
  },
  watch: {
    dateRange(newValue) {
      if (newValue) {
        const [fromDate, toDate] = newValue.split(' to ')
        if (fromDate && toDate) {
          this.filtersChangeHandler()
        }
      } else if (newValue === '') {
        this.filtersChangeHandler()
      }
    },
  },
  created() {
    this.fetchOptions()
  },
  beforeDestroy() {
    if (this.codeInputTimeout) {
      clearTimeout(this.codeInputTimeout)
    }
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
  },
  methods: {
    onProductSearch(search) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }

      this.searchTimeout = setTimeout(() => {
        this.filterProducts(search)
      }, 300)
    },
    filterProducts(search) {
      if (!search || search.trim() === '') {
        // Show only first 15 items when no search
        this.filterProductOptions = this.productOptions.slice(0, 15)
      } else {
        // Filter products by search term
        const searchLower = search.toLowerCase()
        const filtered = this.productOptions.filter(product => product.name.toLowerCase().includes(searchLower)
          || product.code.toLowerCase().includes(searchLower))

        // Limit to first 50 results for performance
        this.filterProductOptions = filtered.slice(0, 50)
      }
    },
    handleDragStart(index, event) {
      this.draggedIndex = index
      const { dataTransfer } = event
      dataTransfer.effectAllowed = 'move'
      dataTransfer.setData('text/html', event.target.innerHTML)
    },
    handleDragOver(index, event) {
      if (index !== this.draggedIndex) {
        const { dataTransfer } = event
        dataTransfer.dropEffect = 'move'
      }
    },
    handleDrop(dropIndex, event) {
      event.preventDefault()
      if (this.draggedIndex !== null && this.draggedIndex !== dropIndex) {
        const draggedItem = this.sortByOptions[this.draggedIndex]
        const newOptions = [...this.sortByOptions]

        // Remove dragged item
        newOptions.splice(this.draggedIndex, 1)

        // Insert at new position
        newOptions.splice(dropIndex, 0, draggedItem)

        this.sortByOptions = newOptions
        this.filtersChangeHandler()
      }
    },
    handleDragEnd() {
      this.draggedIndex = null
    },
    toggleSortOptions() {
      // showSortOptions is already updated by v-model
      // Just prevent closing immediately
    },
    closeSortOptions() {
      this.showSortOptions = false
    },
    debouncedFiltersChange() {
      // Clear the existing timer
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }

      // Set a new timer
      this.debounceTimer = setTimeout(() => {
        this.filtersChangeHandler()
      }, 500) // 500ms delay
    },
    async fetchOptions() {
      try {
        // Fetch company options
        const companyRes = await axios.get('/company_options')
        this.companyOptions = companyRes.data.data.map(item => ({ text: item.text, id: item.text }))

        const { data: buyersRes } = await axios.get('/accounts/buyers_options')
        this.buyerOptions = buyersRes.data

        const { data: usersList } = await axios.get('/accounts/salesmen_options_with_user_id')
        this.usersList = usersList.data

        const productRes = await axios.get('/marg/product_options')
        this.productOptions = productRes.data.data.map(product => ({
          id: product.code,
          code: product.code,
          name: product.name,
          display_text: `${product.name}`,
        }))

        // Initialize with first 15 products
        this.filterProductOptions = this.productOptions.slice(0, 15)
      } catch (error) {
        this.errors = error.response?.data?.error || 'Failed to load filter options. Please refresh the page.'
      }
    },
    filtersChangeHandler() {
      const filtersdata = {}

      if (this.selectedProduct) {
        filtersdata.code = this.selectedProduct.code
      }
      if (this.dateRange) {
        const [dateFrom, dateTo] = this.dateRange.split(' to ')
        if (dateFrom && dateTo) {
          filtersdata.start_date = dateFrom
          filtersdata.end_date = dateTo
        }
      }
      if (this.selectedCompanies) {
        filtersdata.company = this.selectedCompanies.map(company => company.id)
      }
      if (this.selectedCreatedBy) {
        filtersdata.created_by = this.selectedCreatedBy
      }
      if (this.selectedBuyers) {
        filtersdata.buyer = this.selectedBuyers.map(buyer => buyer)
      }
      if (this.out_of_stock && !this.in_stock) {
        filtersdata.out_of_stock = 'true'
      }
      if (this.in_stock && !this.out_of_stock) {
        filtersdata.out_of_stock = 'false'
      }
      if (this.remove_duplicates) {
        filtersdata.unique_shortage = 'true'
      }
      if (this.reminder_requested) {
        filtersdata.reminder_requested = 'true'
      }
      if (this.reminder_acknowledged) {
        filtersdata.reminder_sent = 'true'
      }

      // Handle MRP range
      if (this.mrpMin !== null || this.mrpMax !== null) {
        if (this.mrpMin !== null) {
          filtersdata.min_mrp = this.mrpMin
        }
        if (this.mrpMax !== null) {
          filtersdata.max_mrp = this.mrpMax
        }
      }

      // Handle amount range
      if (this.amountMin !== null || this.amountMax !== null) {
        if (this.amountMin !== null) {
          filtersdata.min_amount = this.amountMin
        }
        if (this.amountMax !== null) {
          filtersdata.max_amount = this.amountMax
        }
      }

      // Handle sort_by priority array - only include enabled options in order
      const enabledSortOptions = this.sortByOptions
        .filter(option => option.enabled)
        .map(option => option.value)

      if (enabledSortOptions.length > 0) {
        filtersdata.short_by = enabledSortOptions
      }

      this.$emit('filtersUpdated', filtersdata)
    },
  },
}
</script>

<style scoped>
.sort-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 8px;
  background: white;
  border: 1px solid #d8d6de;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 400px;
  max-width: 500px;
}

.sort-dropdown-header {
  padding: 12px 16px;
  background-color: #f8f8f8;
  border-bottom: 1px solid #e0e0e0;
  border-radius: 8px 8px 0 0;
  font-weight: 600;
  font-size: 14px;
  color: #5e5873;
}

.sort-priority-container {
  padding: 12px;
  background-color: #ffffff;
  border-radius: 0 0 8px 8px;
}

.sort-items-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sort-item {
  padding: 10px 12px;
  background-color: #f9f9f9;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  cursor: move;
  transition: all 0.3s ease;
  user-select: none;
}

.sort-item:hover {
  border-color: #7367f0;
  box-shadow: 0 2px 4px rgba(115, 103, 240, 0.2);
  background-color: #ffffff;
}

.sort-item.active {
  border-color: #7367f0;
  background-color: #f5f3ff;
}

.sort-item.dragging {
  opacity: 0.5;
  transform: scale(0.98);
}

.priority-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  background-color: #7367f0;
  color: white;
  border-radius: 50%;
  font-size: 12px;
  font-weight: bold;
  margin-right: 8px;
  flex-shrink: 0;
}

.drag-handle {
  cursor: grab;
  color: #6c757d;
  margin-left: auto;
  flex-shrink: 0;
}

.drag-handle:active {
  cursor: grabbing;
}

.position-relative {
  position: relative;
}
</style>
